import React, { useRef } from "react";
import { useAppSelector } from "../../../redux/store";
import { Navigate, useLocation, useOutletContext } from "react-router-dom";
import { MessageLoader } from "./message.loader";
import { MessageSections } from "../../../pages/components/message/message";
import { Sidebar } from "../../../pages/sidebar";
import { OrdersPage } from "../../../pages/orders";
import { Footer } from "../../../pages/footer/footer";
import { Orders } from "../../../pages/orders/my/my";
import OrderPopup from "../../../pages/orders/order-popup/order-popup";
import { OrderModel } from "../../../pages/shared/models/order/order-item.model";
import ProhibitedItems from "../../../pages/prohibited-items";
import Calculate from "../../../pages/calculate";
import { OutletContext } from "../../router";
import { Content, MainContentContainer } from "../../styled";
import RouteError from "../../../pages/info/route-error";
import { globalHeaderRef } from "../../../pages/shared/refs";

export const OrderRoutes = {
    path: 'orders',
    Component: React.memo(() => {
        const ref = useRef(null);
        const { isOpen } = useAppSelector(state => state.sidebarReducer);
        const { matchesTablet, matchesPc } = useAppSelector(state => state.deviceReducer);

        const { pathname } = useLocation();

        const outletContext = useOutletContext<OutletContext>();
        if (outletContext.isWarehouseWorker || outletContext.isAdmin) {
            return <Navigate to={'../'} replace />
        } else if (pathname.endsWith('/orders') || pathname.endsWith('/orders/')) {
            return <Navigate to={'./my'} replace />
        } else {
            return (
                <MessageLoader key={MessageSections.ORDERS} sectionName={MessageSections.ORDERS}>
                    <MainContentContainer id={'main-content-container'} ref={ref}>
                        <Sidebar headerRef={globalHeaderRef} />
                        <Content
                            style={{
                                paddingLeft: isOpen
                                    && (matchesTablet || matchesPc) ? '15rem' : 'unset'
                            }}>
                            <OrdersPage context={{ ...outletContext, mainContentContainerRef: ref }} />
                            <Footer />
                        </Content>
                    </MainContentContainer>
                </MessageLoader>
            )
        }
    }),
    children: [
        {
            path: 'my',
            index: true,
            Component: () => {
                return <Orders />;
            }
        },
        {
            path: 'new',
            Component: () => {
                const outletContext = useOutletContext<OutletContext>();
                return OrderPopup({ mainContentContainerRef: outletContext.mainContentContainerRef })
            }
        },
        {
            path: ':orderId',
            loader: () => {
                return {} as OrderModel
            },
            Component: () => {
                const outletContext = useOutletContext<OutletContext>();
                return OrderPopup({ mainContentContainerRef: outletContext.mainContentContainerRef })
            }
        },
        {
            path: 'dashboard',
            element: <></>
        },
        {
            path: 'prohibited',
            Component: ProhibitedItems
        },
        {
            path: 'calculate',
            element:
                <MessageLoader key={MessageSections.CALCULATE} sectionName={MessageSections.CALCULATE}>
                    <Calculate />
                </MessageLoader>
        },
        {
            path: '*',
            element: <RouteError />
        }
    ]
};
